import isNil from 'lodash-es/isNil';
import { Resource } from '../Resource';
const rootPath = 'oad/irritensio';
const fromRaw = {
    summary: (raw) => {
        const { weedriq_result, weedriq_timestamp, weedriq_value } = raw;
        const weedriq = !isNil(weedriq_result) && !isNil(weedriq_timestamp) && !isNil(weedriq_value)
            ? { value: weedriq_value, timestamp: weedriq_timestamp, result: weedriq_result }
            : undefined;
        return {
            horizon: raw.horizon,
            result: raw.result,
            timestamp: raw.timestamp,
            T_CAL: raw.T_CAL,
            T_CAPA: raw.T_CAPA,
            value: raw.value,
            weedriq
        };
    }
};
const irritensio = Resource((requesterBuilder) => {
    return {
        summary: (query) => requesterBuilder({
            path: `${rootPath}`,
            requestCtx: {
                params: {
                    query: {
                        plot: query?.plotId,
                        since: query?.since,
                        before: query?.before,
                        metrics: query?.metric
                    }
                },
                transform: (results) => results ? results.map(fromRaw.summary) : []
            }
        })
    };
});
export default irritensio;
